import Keycloak from 'keycloak-js';

export const keycloakConfig = {
    url:
        process.env.NODE_ENV === 'development'
            ? 'https://my-devci.poc.learning.amplify.com/auth/'
            : 'https://my.amplify.com/auth',
    realm: 'Amplify',
    clientId: 'mclass-lantern-assessment',
};

export const keycloakInitOptions = {
    onLoad: 'check-sso',
    checkLoginIframe: false,
};

const keycloak = new Keycloak(keycloakConfig);
export default keycloak;
